import { useRef } from "react";
import { motion, useAnimationFrame, useMotionTemplate, useMotionValue, useTransform } from "framer-motion";

// A glowing dot that travels around the card's outline.
const MovingBorder = ({ children, duration = 3000, className = "", borderRadius = "1.75rem" }) => {
  const pathRef = useRef(null);
  const progress = useMotionValue(0);

  useAnimationFrame((time) => {
    const length = pathRef.current?.getTotalLength();
    if (length) progress.set((time * (length / duration)) % length);
  });

  const x = useTransform(progress, (v) => pathRef.current?.getPointAtLength(v).x ?? 0);
  const y = useTransform(progress, (v) => pathRef.current?.getPointAtLength(v).y ?? 0);
  const transform = useMotionTemplate`translateX(${x}px) translateY(${y}px) translateX(-50%) translateY(-50%)`;

  return (
    <div className={`relative p-[1px] overflow-hidden ${className}`} style={{ borderRadius }}>
      <div className="absolute inset-0" style={{ borderRadius: `calc(${borderRadius} * 0.96)` }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          className="absolute h-full w-full"
          width="100%"
          height="100%"
        >
          <rect fill="none" width="100%" height="100%" rx="30%" ry="30%" ref={pathRef} />
        </svg>
        <motion.div style={{ position: "absolute", top: 0, left: 0, display: "inline-block", transform }}>
          <div className="h-36 w-36 opacity-90 blur-md bg-[radial-gradient(rgb(var(--c-accent))_25%,rgb(var(--c-accent)/0.35)_45%,transparent_65%)]" />
        </motion.div>
      </div>
      <div
        className="relative bg-[linear-gradient(90deg,rgb(var(--c-card)/0.9)_0%,rgb(var(--c-card-2)/0.9)_100%)] border border-ink/10 backdrop-blur-xl w-full h-full"
        style={{ borderRadius: `calc(${borderRadius} * 0.96)` }}
      >
        {children}
      </div>
    </div>
  );
};

export default MovingBorder;
